import { DeleteOutlineOutlined, DescriptionOutlined, FileUploadOutlined } from "@mui/icons-material";
import { Checkbox, styled } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";

const StyledDataGrid = styled(DataGrid)({
    "& .MuiDataGrid-columnSeparator": {
        display: "none",
    },
    "& .MuiDataGrid-virtualScroller": {
        overflowX: "hidden",
    },
    "& .MuiDataGrid-scrollbar--horizontal": {
        display: "none",
    },
    "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
        outline: "none !important",
    },
});

const StyledHeaderIcon = styled("div")({
    fontWeight: 600,
    fontSize: "13px",
    display: "flex",
    alignItems: "center",
    gap: "4px",
});

const DocumentTypeAdminDataGrid = ({ rows, uploadGrid, readGrid, deleteGrid, onRowUpdate }) => {
    const getHeader = () => {
        if (uploadGrid) {
            return (
                <StyledHeaderIcon>
                    <FileUploadOutlined />
                    Upload
                </StyledHeaderIcon>
            );
        } else if (readGrid) {
            return (
                <StyledHeaderIcon>
                    <DescriptionOutlined />
                    Read
                </StyledHeaderIcon>
            );
        } else if (deleteGrid) {
            return (
                <StyledHeaderIcon>
                    <DeleteOutlineOutlined />
                    Delete
                </StyledHeaderIcon>
            );
        }
    };

    const isCheckBoxChecked = (params) => {
        if (uploadGrid) {
            return params.row?.canUpload;
        } else if (readGrid) {
            return params.row?.canRead;
        } else if (deleteGrid) {
            return params.row?.canDelete;
        }
    };

    const handleCheckboxClick = (row, checked) => {
        const updatedRow = { ...row };
        if (uploadGrid) {
            updatedRow.canUpload = checked;
        } else if (readGrid) {
            updatedRow.canRead = checked;
        } else if (deleteGrid) {
            updatedRow.canDelete = checked;
        }
        onRowUpdate(updatedRow);
    };

    const columns = [
        {
            field: "displayName",
            headerName: "",
            flex: 1,
            renderHeader: () => {
                return getHeader();
            },
            renderCell: (params) => {
                return params.row?.displayName;
            },
        },
        {
            field: "checkbox",
            headerName: "",
            width: 5,
            sortable: false,
            renderHeader: () => {
                const allChecked = rows.length > 0 && rows.every((row) => isCheckBoxChecked({ row }));
                const someChecked = rows.some((row) => isCheckBoxChecked({ row })) && !allChecked;
                return (
                    <Checkbox
                        checked={allChecked}
                        indeterminate={someChecked}
                        onChange={(e) => {
                            rows.forEach((row) => {
                                handleCheckboxClick(row, e.target.checked);
                            });
                        }}
                    />
                );
            },
            renderCell: (params) => {
                return (
                    <Checkbox
                        checked={isCheckBoxChecked(params)}
                        onChange={(e) => {
                            handleCheckboxClick(params.row, e.target.checked);
                        }}
                    />
                );
            },
        },
    ];

    return (
        <div style={{ width: "33.3333%" }}>
            <StyledDataGrid columns={columns} rows={rows} sx={{ maxHeight: 422 }} disableColumnMenu hideFooter />
        </div>
    );
};

export default DocumentTypeAdminDataGrid;
